var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCanceledCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_762_1771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.2001 6.15284H42.5516V3.32272H34.0907V6.15284H19.9579V3.32272H11.4969V6.15284H5.84851V26.8723C2.51204 28.46 0.200073 31.8641 0.200073 35.7984C0.200073 41.2456 4.63173 45.6773 10.079 45.6773C14.0132 45.6773 17.4173 43.3653 19.005 40.0288H48.2001V6.15284ZM36.9032 6.13522H39.7391V8.97115H36.9032V6.13522ZM14.3094 6.13522H17.1454V8.97115H14.3094V6.13522ZM11.4969 8.96534V11.7837H19.9579V8.96534H34.0907V11.7837H42.5516V8.96534H45.3876V14.6255H8.66101V8.96534H11.4969ZM10.079 42.8648C6.18254 42.8648 3.01257 39.6948 3.01257 35.7984C3.01257 31.9019 6.18254 28.732 10.079 28.732C13.9754 28.732 17.1454 31.9019 17.1454 35.7984C17.1454 39.6948 13.9754 42.8648 10.079 42.8648ZM19.8557 37.2163C19.9225 36.7531 19.9579 36.2798 19.9579 35.7984C19.9579 30.3511 15.5262 25.9195 10.079 25.9195C9.59757 25.9195 9.12423 25.9548 8.66101 26.0217V17.438H45.3876V37.2163H19.8557Z",
    fill: "#19A69D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7938 28.7437H25.6063V31.5562H22.7938V28.7437Z",
    fill: "#19A69D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9149 23.0952H42.5516V25.9077H36.9149V23.0952Z",
    fill: "#19A69D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4423 23.0952H34.079V25.9077H28.4423V23.0952Z",
    fill: "#19A69D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9696 23.0952H25.6063V25.9077H19.9696V23.0952Z",
    fill: "#19A69D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9149 28.7437H42.5516V31.5562H36.9149V28.7437Z",
    fill: "#19A69D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4423 28.7437H34.079V31.5562H28.4423V28.7437Z",
    fill: "#19A69D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.076 31.8126L10.0789 33.8097L8.08186 31.8126L6.09314 33.8013L8.0902 35.7984L6.09314 37.7953L8.08186 39.7841L10.0789 37.7871L12.076 39.7841L14.0647 37.7953L12.0676 35.7984L14.0647 33.8013L12.076 31.8126Z",
    fill: "#19A69D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_762_1771"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.200073 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanceledCalendar);
export default __webpack_public_path__ + "static/media/canceled-calendar.a2b22c1d886d5c7e59307f7475221349.svg";
export { ForwardRef as ReactComponent };